import { isInputPlayQueueFromState } from "../helpers";
import { updateAudiosFromPlayQueue } from "./updateAudiosFromPlayQueue";
import type { AudioContextModel } from "models/app/player/AudioContext";

export function loginChange(context: AudioContextModel) {
    if (isInputPlayQueueFromState()) updateAudiosFromPlayQueue(null, context);
}